import React from 'react';
import './UpgradeModal.css';

const UpgradeModal = ({ currentTier, onClose, onUpgrade }) => {
  const plans = [
    {
      name: 'Free',
      tier: 'free',
      price: '$0',
      period: 'forever',
      features: [
        '1 Persona',
        '4 Event Sequences',
        '5 Daily Predictions',
        'Basic Support',
        'Ads Included'
      ],
      color: 'gray',
      popular: false
    },
    {
      name: 'Paid',
      tier: 'paid',
      price: '$2.99',
      period: 'monthly, billed annually',
      features: [
        '3 Personas',
        '8 Event Sequences',
        '15 Daily Predictions',
        'Ad-Free Experience',
        'Advanced Insights'
      ],
      color: 'purple',
      popular: true
    },
    {
      name: 'Premium',
      tier: 'premium',
      price: '$6.99',
      period: 'monthly, billed annually with 8%',
      features: [
        '5 Personas',
        '8 Event Sequences',
        '25 Daily Predictions',
        'Ad-Free Experience',
        'Advanced Insights',
        'Early Access Features',
        'Incorporate valid events',
        'Category & localization focus*'
      ],
      color: 'gold',
      popular: false
    }
  ];

  return (
    <div className="upgrade-modal-overlay" onClick={onClose}>
      <div className="upgrade-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="upgrade-modal-close" onClick={onClose}>
          ✕
        </button>

        <div className="upgrade-header">
          <h2 className="upgrade-title">✨ Upgrade Your Experience ✨</h2>
          <p className="upgrade-subtitle">
            Choose the perfect plan to unlock your full potential
          </p>
        </div>

        <div className="plans-grid">
          {plans.map((plan) => (
            <div 
              key={plan.tier}
              className={`plan-card ${plan.popular ? 'popular' : ''} ${currentTier === plan.tier ? 'current' : ''}`}
            >
              {plan.popular && (
                <div className="popular-badge">
                  ⭐ Most Popular
                </div>
              )}
              
              {currentTier === plan.tier && (
                <div className="current-badge">
                  ✓ Current Plan
                </div>
              )}

              <div className="plan-header">
                <h3 className="plan-name">{plan.name}</h3>
                <div className="plan-price">
                  <span className="price-amount">{plan.price}</span>
                  <span className="price-period">{plan.period}</span>
                </div>
              </div>

              <ul className="plan-features">
                {plan.features.map((feature, index) => (
                  <li key={index} className="feature-item">
                    <span className="feature-icon">✓</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <button
                className={`plan-btn ${currentTier === plan.tier ? 'current' : ''}`}
                onClick={() => {
                  if (currentTier !== plan.tier && plan.tier !== 'free') {
                    onUpgrade(plan.tier);
                  }
                }}
                disabled={currentTier === plan.tier || plan.tier === 'free'}
              >
                {currentTier === plan.tier 
                  ? 'Current Plan' 
                  : plan.tier === 'free' 
                    ? 'Free Forever' 
                    : 'Upgrade Now'}
              </button>
            </div>
          ))}
        </div>

        <div className="upgrade-footer">
          <p className="footer-note">
            💳 Secure payment powered by Stripe&#8482; • Cancel anytime
          </p>
          <p className="footer-guarantee">
            🔒 30-day money-back guarantee
          </p>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;